import { Suspense } from 'react';

import ContentRoutes from './ContentRoutes';
import { CircularProgress } from '@mui/material';

const LOADING = (
    <>
        <CircularProgress />
    </>
);

const Content = () => {
    return (
        <main className='content'>
            <Suspense fallback={LOADING}>
                <ContentRoutes />
            </Suspense>
        </main>
    );
};

export default Content;
